import React from 'react';
import styled from 'styled-components/macro';
import { useTranslate } from '../contexts/languageContext';
import TablaMunicipios from './TablaRankingMunicipios/TablaRankingMun';
import TablaMunicipiosMobile from './TablaRankingMunicipios/TablaRankingMunMobile';
import TablaPartidos from './TablaRankingPar';
import TablaEstadisticasListas from './TablaEstadisticasListas/TablaEstadisticasListas';
import { useIsMobile, useIsDesktop } from '../hooks/useMediaQuery';

const RankingStats = ({ tipo, title, elec, data, nomenclator }) => {
  const t = useTranslate();
  const isMobile = useIsMobile();
  const isDesktop = useIsDesktop();

  return (
    <>

      <SStatsContent isDesktop={isDesktop}>
        {tipo !== 'VP' ? (
          !isMobile ? (
            <TablaMunicipios
              tipo={tipo}
              tipoStats={title}
              data={data.lisrank}
              nomenclator={nomenclator}
              elec={elec}
            />
          ) : (
            <TablaMunicipiosMobile
              title={title}
              data={data.lisrank}
              nomenclator={nomenclator}
              elec={elec}
            />
          )
        ) : (
          <TablaPartidos data={data.lisrank} nomenclator={nomenclator} />
        )}
      </SStatsContent>
    </>
  );
};

export default RankingStats;

const SStatsContent = styled.article`
  height: auto;
  margin: ${({ isDesktop }) => isDesktop && '3rem 3rem 5rem 3rem'};
  & h3 {
    font-weight: bold;
    font-size: 1.6rem;
    text-transform: uppercase;
    margin: ${({ isDesktop }) => !isDesktop && '3% 2% 0'};
  }
`;

const Title = styled.h3`
  font-weight: bold;
  font-size: 1.6rem;
  text-transform: uppercase;
  margin: ${({ isDesktop }) => !isDesktop && '3% 2% 0'};
`;
